import React from 'react';
import './styles.scss'
export default function SectionTitle({ children }) {
  return (
    <div className='section-title'>
      {children}
    </div>
  );
}
